import Axios from 'api/client';
import { CompanyContact, Contact } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

interface ContactAssociationParams {
    contact_id: number;
}

interface PointOfContactParams {
    contact_id: number;
}

const fetchCompanyContacts = (accountId: number, contactId: number, params: FilterParams) =>
    Axios.get<PaginatedData<CompanyContact>>(
        `/accounts/${accountId}/company-associations/${contactId}`,
        {
            params,
        },
    ).then(response => response.data);

const associateContact = (
    accountId: number,
    companyId: number,
    params: ContactAssociationParams,
) => {
    return Axios.post<Contact>(
        `/accounts/${accountId}/company-associations/${companyId}/associate`,
        params,
    ).then(response => response.data);
};

const disassociateContact = (
    accountId: number,
    companyId: number,
    params: ContactAssociationParams,
) => {
    return Axios.post<Contact>(
        `/accounts/${accountId}/company-associations/${companyId}/disassociate`,
        params,
    ).then(response => response.data);
};

const makePointOfContact = (accountId: number, companyId: number, params: PointOfContactParams) => {
    return Axios.post<Contact>(
        `/accounts/${accountId}/company-associations/${companyId}/point-of-contact`,
        params,
    ).then(response => response.data);
};

const removePointOfContact = (
    accountId: number,
    companyId: number,
    params: PointOfContactParams,
) => {
    return Axios.delete(
        `/accounts/${accountId}/company-associations/${companyId}/point-of-contact`,
        {
            data: params,
        },
    ).then(response => response.data);
};

export {
    fetchCompanyContacts,
    associateContact,
    disassociateContact,
    makePointOfContact,
    removePointOfContact,
};
